import React, { useContext } from 'react';
import ScrollToTop from '../ScrollToTop';
import { Context } from '../../StoreContext/Context';

const Footer = () => {
  const { clientName, infoFaq, info } = useContext(Context);

  return (
    <>
      {/* footer begin */}
      <footer className="style-2">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3">
              <img src={info?.logo} className="logo-small w-50" alt="" />
              <br />
            </div>
            <div className="col-md-6">
              © Copyright 2022 - {clientName} - {` `}
              {infoFaq?.helpdesk_languages?.description?.pt}
              <a
                href={infoFaq?.helpdesk_languages?.link?.pt}
                target="_blank"
                rel="noreferrer"
              >
                <span className="id-color ml-1">
                  {infoFaq?.helpdesk_languages?.data?.pt}
                </span>
              </a>
            </div>
            <div className="col-md-3 text-right">
              <div className="social-icons">
                {infoFaq?.social_media?.site && (
                  <a
                    href={infoFaq?.social_media?.site}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-globe fa-lg" />
                  </a>
                )}

                {infoFaq?.social_media?.linkedin && (
                  <a
                    href={infoFaq?.social_media?.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-linkedin fa-lg" />
                  </a>
                )}

                {infoFaq?.social_media?.instagram && (
                  <a
                    href={infoFaq?.social_media?.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-instagram fa-lg" />
                  </a>
                )}

                {infoFaq?.social_media?.facebook && (
                  <a
                    href={infoFaq?.social_media?.facebook}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-facebook fa-lg" />
                  </a>
                )}
                {infoFaq?.social_media?.youtube && (
                  <a
                    href={infoFaq?.social_media?.youtube}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-youtube-play fa-lg" />
                  </a>
                )}
                {infoFaq?.social_media?.twitter && (
                  <a
                    href={infoFaq?.social_media?.twitter}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-twitter fa-lg" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop />
      </footer>
      {/* footer close */}
    </>
  );
};

export default Footer;
